import React from 'react'
import './store.css'





const Store = (props) => {
  
  const name = props.name;

  
  return (
    <section>
      
       
       <div className='store'>
       <h2>{/*{name} is */}Under construction. Press Home.</h2>
        
         <div className='shop__icon'>
         
            
         </div>
        
       </div>
       
      
    </section>
  )
}

export default Store
